import { render, staticRenderFns } from "./lufax.vue?vue&type=template&id=88147c3e&scoped=true&"
import script from "./lufax.vue?vue&type=script&lang=js&"
export * from "./lufax.vue?vue&type=script&lang=js&"
import style0 from "./lufax.vue?vue&type=style&index=0&id=88147c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88147c3e",
  null
  
)

export default component.exports